/* Grok home d v3 (21-10-2026): <grok-slideshow>. Hero autoplays with a visible pause/play button;
   the featured panel (data-autoplay="0") only moves when a shopper uses the arrows, dots or swipe. */
(function () {
  if (customElements.get('grok-slideshow')) return;
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  class GrokSlideshow extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.track = this.querySelector(':scope > .gh-track');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.children);
      this.n = this.slides.length;
      if (this.n < 2) return; /* one slide: static, no JS */
      this._ready = true;
      this.i = 0; this.timer = null; this.hold = false; this.userPaused = false;
      this.speed = parseInt(this.dataset.speed, 10) || 7000;
      this.wantsAuto = this.dataset.autoplay === '1';
      this.dots = Array.prototype.slice.call(this.querySelectorAll(':scope > .gh-ctrl [data-gh-dot]'));
      this.pp = this.querySelector(':scope > .gh-ctrl [data-gh-pp]');
      var self = this;
      if (this._bound) { this.addGlobal(); this.go(0, false); this.syncPP(); this.play(); return; }
      this._bound = true;
      this.dots.forEach(function (d) { d.addEventListener('click', function () { self.go(+d.dataset.ghDot, true); }); });
      var prev = this.querySelector(':scope > [data-gh-prev]'), next = this.querySelector(':scope > [data-gh-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.i - 1, true); });
      if (next) next.addEventListener('click', function () { self.go(self.i + 1, true); });
      if (this.pp) this.pp.addEventListener('click', function () { self.userPaused = !self.userPaused; self.syncPP(); self.play(); });
      this.addEventListener('mouseenter', function () { self.hold = true; self.stop(); });
      this.addEventListener('mouseleave', function () { self.hold = false; self.play(); });
      /* keyboard focus pauses only while it is inside; a mouse click on a control does not hold it */
      this.addEventListener('focusin', function (e) { var t = e.target; var kb = false; try { kb = t.matches(':focus-visible'); } catch (x) {} if (kb) { self.hold = true; self.stop(); } });
      this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) { self.hold = false; self.play(); } });
      this._vis = function () { self.play(); };
      this._rm = function () { self.syncPP(); self.play(); };
      this.addGlobal();
      /* swipe (pointer events, ~40px threshold); a swipe cancels the click on a linked slide */
      var x0 = null, swiped = false;
      this.track.addEventListener('pointerdown', function (e) { x0 = e.clientX; swiped = false; });
      this.track.addEventListener('pointerup', function (e) {
        if (x0 !== null && Math.abs(e.clientX - x0) > 40) { swiped = true; self.go(self.i + (e.clientX < x0 ? 1 : -1), true); }
        x0 = null;
      });
      this.track.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);
      this.go(0, false); this.syncPP(); this.play();
    }
    disconnectedCallback() {
      this.stop();
      if (this._vis) document.removeEventListener('visibilitychange', this._vis);
      if (this._rm && reduceMq.removeEventListener) reduceMq.removeEventListener('change', this._rm);
      this._ready = false;
    }
    addGlobal() {
      document.addEventListener('visibilitychange', this._vis);
      if (reduceMq.addEventListener) reduceMq.addEventListener('change', this._rm);
    }
    canAuto() { return this.wantsAuto && !reduceMq.matches; }
    go(k, byUser) {
      this.i = (k + this.n) % this.n;
      this.track.style.transform = 'translateX(' + (-100 * this.i) + '%)';
      var i = this.i;
      this.dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      this.slides.forEach(function (s, j) {
        var on = j === i;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
        if (s.tagName === 'A') s.tabIndex = on ? 0 : -1;
        s.querySelectorAll('a,button').forEach(function (a) { if (!a.classList.contains('gh-slide__mlink')) a.tabIndex = on ? 0 : -1; });
      });
      this.dispatchEvent(new CustomEvent('gh:change', { detail: { index: this.i, byUser: !!byUser } }));
      if (byUser) this.play();
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    play() {
      this.stop();
      if (this.canAuto() && !this.hold && !this.userPaused && !document.hidden && !this.editorHold) {
        var self = this; this.timer = setInterval(function () { self.go(self.i + 1, false); }, this.speed);
      }
    }
    syncPP() {
      if (!this.pp) return;
      if (!this.wantsAuto || reduceMq.matches) { this.pp.hidden = true; return; }
      this.pp.hidden = false;
      var paused = this.userPaused;
      this.pp.dataset.state = paused ? 'paused' : 'playing';
      this.pp.setAttribute('aria-label', paused ? (this.dataset.labelPlay || 'Play') : (this.dataset.labelPause || 'Pause'));
    }
  }
  customElements.define('grok-slideshow', GrokSlideshow);
  /* theme editor: show the selected block's slide and hold autoplay while it is selected */
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target, ss = s && s.closest && s.closest('grok-slideshow');
    if (ss && ss._ready && s.dataset.index) { ss.editorHold = true; ss.go(+s.dataset.index, false); ss.stop(); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var ss = e.target && e.target.closest && e.target.closest('grok-slideshow');
    if (ss && ss._ready) { ss.editorHold = false; ss.play(); }
  });
})();
